import FinancialsTemplateFieldsFragment from "components/financials/modern/graphql/fragments/FinancialsTemplateFieldsFragment";
import IndicatorFieldsFragment from "components/financials/modern/graphql/fragments/IndicatorFieldsFragment";
import gql from "graphql-tag";
import CompanyIssuerFields from "lib/graphql/fragments/CompanyIssuerFields";

export default gql`
  query FinancialsSheetForComparison(
    $indicatorDataSource: IndicatorDataSource!
    $indicators: [IndicatorID!]!
    $statementType: FinancialsStatementType!
    $currency: String!
    $vertical: PlatformVertical!
    $adversaries: [FinancialsSheetComparisonAdversaryInput!]!
    $limit: Int!
    $limitCriterion: FinancialsSheetLimitCriterion!
    $filterByInterim: String
    $filterByReportDateAfter: Date
    $filterByReportDateBefore: Date
  ) {
    financialsSheetForComparison(
      indicatorDataSource: $indicatorDataSource
      indicators: $indicators
      statementType: $statementType
      currency: $currency
      vertical: $vertical
      adversaries: $adversaries
      limit: $limit
      limitCriterion: $limitCriterion
      filterByInterim: $filterByInterim
      filterByReportDateAfter: $filterByReportDateAfter
      filterByReportDateBefore: $filterByReportDateBefore
    ) {
      reportDates
      indicators {
        ...IndicatorFields
        preferredDocumentation {
          languageCode
          name
          abbreviation
          description
        }
      }
      adversaries {
        issuer {
          ...CompanyIssuerFields
        }
        tickerSymbol
        reportDates

        isTrailingTwelveMonths
        isPreliminaryTrailingTwelveMonths
        isQuarterly
        isAnnual

        indicators {
          objectId
          viewerCanSee
          series {
            theme {
              backgroundColor
              textColor
              formatting
            }
            formattedValue
            ... on FinancialIndicatorSeriesFinancialNode {
              value
            }
            ... on FinancialIndicatorSeriesCurrencyNode {
              value
            }
            ... on FinancialIndicatorSeriesNumberNode {
              value
            }
            ... on FinancialIndicatorSeriesPercentNode {
              value
            }
            ... on FinancialIndicatorSeriesRatioNode {
              value
            }
            ... on FinancialIndicatorSeriesMetricNode {
              value
            }
            ... on FinancialIndicatorSeriesTextNode {
              text
            }
          }
        }
      }
      systemTemplate {
        ...FinancialsTemplateFields
        indicators {
          ...IndicatorFields
        }
      }
      overridingTemplate {
        ...FinancialsTemplateFields
        indicators {
          ...IndicatorFields
        }
      }
      viewerSelectedTemplate {
        ...FinancialsTemplateFields
        indicators {
          ...IndicatorFields
        }
      }
    }
  }
  ${IndicatorFieldsFragment}
  ${FinancialsTemplateFieldsFragment}
  ${CompanyIssuerFields}
`;
